import { useEffect, useState } from 'react';
import classes from './Footer.module.css';

const Footer = () => {
  const [currentYear, setCurrentYear] = useState('2022');

  useEffect(() => {
    const Timestamp = new Date().toLocaleString("en-CA", {
      timeZone: "America/Vancouver",
      timeZoneName: "short",
      year: "numeric",
      month: "long",
    }).split(' ');

    setCurrentYear(Timestamp[1]);
  }, [])

  return (
    <div className={classes.footerContainer}>
      <footer>&copy;{currentYear === '2022' ? '2022' : '2022 - ' + currentYear }. Kaori Era. All Rights Reserved.</footer>
    </div>
  );
};

export default Footer;
